export enum ViewportDeviceType {
  current = 'current',
  desktop = 'desktop',
  tablet = 'tablet',
  mobile = 'mobile',
}
